import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx } from "vue"

import { reactive, ref } from 'vue';
import CloseThick from '@/components/CloseThick.vue';
import Map from '@/types/LinkedMap';
import NotificationPopup, {INotificationPopupProps, INotificationPopupExpose} from './NotificationPopup.vue';
import NotificationType from '@/types/NotificationType';
import DeferredPromise from '@/types/DeferredPromise';

export interface INotify {
    type?: NotificationType;
    title?: string;
    msg: string;
    /**
     * duration
     * 0 for not hiding on its own
     */
    dur?: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationPopups',
  setup(__props, { expose: __expose }) {

__expose({ add });
const popUpProps = reactive(new Map<number, INotificationPopupProps>());
const popUpRefs = new Map<number, DeferredPromise<INotificationPopupExpose>>();
const hovering = ref(false);
const disableResume = ref(false);
// let tail = 0; // for bug tracking only...
let head = -1;

function setPopupRef(el: INotificationPopupExpose) {
    if (el) {
        const id = el.getId();
        let promise = popUpRefs.get(id);
        if (!promise) {
            promise = new DeferredPromise<INotificationPopupExpose>();
            popUpRefs.set(id, promise);
        }
        promise.Resolve(el);        
    }
}
function pauseTimeout() {
    popUpRefs.forEach(p => p.then(x=>x.pause()));
}
function resumeTimeout() {
    popUpRefs.forEach(p => p.then(x=>x.resume()));
}
function onMouseEnter() {
    hovering.value = true;
    pauseTimeout();
}
function onMouseLeave() {
    hovering.value = false;
    if (!disableResume.value) resumeTimeout();
}
function getNextId(): number {
    if (++head >= 9999999) head = 0;
    return head;
}
async function add(props: INotify) {
    const processed: INotificationPopupProps = {
        id: getNextId(),
        title: props.title,
        msg: props.msg,
        type: props.type ?? NotificationType.INFO,
        duration: props.dur ?? (props.type === NotificationType.ERR ? 0 : 3000),
        startPaused: hovering.value || disableResume.value,
    };
    const promise = new DeferredPromise<INotificationPopupExpose>();
    popUpRefs.set(processed.id, promise);
    popUpProps.set(processed.id, processed);
    return await promise;
}
function destroyAll(e: Event): void {
    e.stopPropagation();
    popUpRefs.forEach(a => a.then(x=>x.destroy()));
    // following probably not need
    //popUpRefs.clear();
    //popUpProps.clear();
}
function onDestroy(id: number) {
    popUpRefs.delete(id);
    popUpProps.delete(id);
    if (popUpProps.size <= 0) {
        disableResume.value = false;
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_TransitionGroup, {
    tag: "div",
    name: "notification-fade",
    class: "notification-group",
    onMouseenter: onMouseEnter,
    onMouseleave: onMouseLeave,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (disableResume.value=!disableResume.value))
  }, {
    default: _withCtx(() => [
      (popUpProps.size > 1)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "closeAll",
            onClick: destroyAll
          }, [
            _createVNode(CloseThick)
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(popUpProps.reversed(), (item) => {
        return (_openBlock(), _createBlock(NotificationPopup, {
          ref_for: true,
          ref: (el)=>setPopupRef(el as unknown as INotificationPopupExpose),
          key: item.id,
          id: item.id,
          title: item.title,
          msg: item.msg,
          type: item.type,
          duration: item.duration,
          "start-paused": item.startPaused,
          onDestroy: onDestroy
        }, null, 8, ["id", "title", "msg", "type", "duration", "start-paused"]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})